export const authPages: string[] = ["login", "reset-password"];
export const userPages: string[] = ["setup"];
export const dashboardPages: string[] = [
  "index",
  "admin",
  "tickets",
  "profile",
];
